import React from 'react';
import type { ChatAgentType } from '@constants/chat-agents';
import type { BlockContent } from '../../../../types/chat-message';
import './ConfirmSwitchMessage.scss';

interface ConfirmSwitchMessageProps {
  messageId: string;
  pendingAgent: ChatAgentType;
  isDisabled: boolean;
  originalBlockContents?: BlockContent[];
  onStay: (messageId: string, blockContents?: BlockContent[]) => void;
  onLeave: (messageId: string, pendingAgent: ChatAgentType) => void;
}

const ConfirmSwitchMessage: React.FC<ConfirmSwitchMessageProps> = ({
  messageId,
  pendingAgent,
  isDisabled,
  originalBlockContents,
  onStay,
  onLeave,
}) => {
  return (
    <div className={`confirm-switch-message ${isDisabled ? 'disabled' : ''}`}>
      <p className="confirm-switch-text">
        Bạn chưa hoàn thành yêu cầu hiện tại, bạn có muốn tiếp tục không?
      </p>
      <div className="confirm-switch-actions">
        <button
          className="confirm-switch-btn confirm-switch-btn-stay"
          onClick={() => !isDisabled && onStay(messageId, originalBlockContents)}
          disabled={isDisabled}
          type="button"
        >
          Có
        </button>
        <button
          className="confirm-switch-btn confirm-switch-btn-leave"
          onClick={() => !isDisabled && onLeave(messageId, pendingAgent)}
          disabled={isDisabled}
          type="button"
        >
          Không
        </button>
      </div>
    </div>
  );
};

export default ConfirmSwitchMessage;
